import { Button, ButtonProps, Box, BoxProps, Typography, TypographyProps } from "@mui/material";
import { ReactNode, useCallback, MouseEventHandler, MouseEvent } from "react";
import styles from "./GenericButton.module.css";

export interface GenericButtonProps {
	custom?: {
		size?: "small" | "medium" | "large" | "login";
		kind?: "primary" | "secondary" | "delete";
	};
	state?: {
		disabled?: boolean;
	};
	hooks?: {
		onClick?: MouseEventHandler<HTMLButtonElement>;
	};
	renderers: {
		iconRenderer?: () => ReactNode;
		textRenderer: () => ReactNode;
	};
	slots?: {
		buttonContainer?: ButtonProps;
		buttonText?: TypographyProps;
		buttonIcon?: BoxProps;
	};
}

const sizeToClassNameMapper = {
	small: styles.small,
	medium: styles.medium,
	large: styles.large,
	login: styles.login,
};

const kindToClassNameMapper = {
	primary: styles.primary,
	secondary: styles.secondary,
	delete: styles.delete,
};

export const GenericButton = ({ custom, renderers, state, slots, hooks }: GenericButtonProps) => {
	const handleClick = useCallback(
		(e: MouseEvent<HTMLButtonElement>) => {
			if (state?.disabled) return;
			void hooks?.onClick?.(e);
		},
		[state?.disabled, hooks],
	);

	return (
		<Button
			className={`
            ${styles.buttonContainer} 
            ${sizeToClassNameMapper[custom?.size || "small"]} 
            ${kindToClassNameMapper[custom?.kind || "primary"]}
            ${state?.disabled ? styles.disabled : ""}
            `}
			{...slots?.buttonContainer}
			onClick={handleClick}
		>
			{renderers?.iconRenderer && (
				<Box className={styles.buttonIcon} {...slots?.buttonIcon}>
					{renderers.iconRenderer()}
				</Box>
			)}
			<Typography className={styles.buttonText} {...slots?.buttonText}>
				{renderers.textRenderer()}
			</Typography>
		</Button>
	);
};
